// extracted by mini-css-extract-plugin
export default {"shake":"Roles_shake__6eDfB","title":"Roles_title__saqH4","ui5xlhc":"Roles_ui5xlhc__kjrhj","box":"Roles_box__CaBmb","ui5xlhm":"Roles_ui5xlhm__2rJEw","desc":"Roles_desc__aZosP"};